import React, { useEffect, useState } from 'react'
import { useAppSelector } from 'redux-store/hooks'
import { channelSelector } from 'redux-store/channel/channel.selectors'
import { SolidsportRedIcon } from 'pages/native/onBoarding/components'
import { Skeleton } from 'pages/native/onBoarding/components'

import styles from './HeroImage.module.scss'

export const HeroImage = () => {
  const channel = useAppSelector(channelSelector)
  const [logo, setLogo] = useState('')
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => {
    const newLogo =
      channel?.data?.logo_image_url ||
      channel?.data?.secondary_logo_image_url ||
      ''

    if (newLogo !== logo) {
      setLogo(newLogo)
      setIsLoaded(false)
    }
  }, [channel, logo])

  return (
    <div className={styles.HeroImageContainer}>
      {logo ? (
        <>
          {!isLoaded && (
            <Skeleton width={200} height={120} radius={2} type="image" />
          )}
          <img
            className={`${styles.HeroImage} ${isLoaded ? styles.loaded : ''}`}
            src={logo}
            alt="App Logo"
            onLoad={() => setIsLoaded(true)}
            onError={() => setIsLoaded(false)}
          />
        </>
      ) : (
        <div className={styles.FallbackImage}>
          <SolidsportRedIcon />
        </div>
      )}
    </div>
  )
}
